import Cookies from "js-cookie";
import { Analytics, EcommerceEvent } from "./types";

type GoogleBookEnvironment = "production" | "sandbox";

export class GoogleBookSourceProvider {
  initialize(client: GoogleBookClient) {
    let urlParams = new URLSearchParams(window.location.search);

    const rwgToken = urlParams.get("rwg_token");

    if (rwgToken) {
      Cookies.set("rwg_token", rwgToken, { expires: 30 });
    }

    return GoogleBookAnalytics(client.environment);
  }
}

interface GoogleBookClientOptions {
  sendPageView?: boolean;
}

export interface GoogleBookClient extends GoogleBookClientOptions {
  provider: "google_book";
  environment: GoogleBookEnvironment;
}

export function makeGoogleBookClient(
  environment: GoogleBookEnvironment,
  options?: GoogleBookClientOptions
): GoogleBookClient {
  return {
    provider: "google_book",
    environment,
    sendPageView: options?.sendPageView ?? true,
  };
}

function GoogleBookAnalytics(environment: GoogleBookEnvironment): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: () => {},
    screen: () => {},
    ecommerceEvent: (event: EcommerceEvent) => {
      switch (event.event) {
        case "Order Completed":
          const rwgToken =
            // since it is sandbox environment, we are using a hardcoded token as advised by their documentation
            // this is also to ensure we can start tracking the conversion events for sandbox environment so that we don't have to create the orders manually on production
            environment === "sandbox"
              ? "AJKvS9WeONmWKEwjG0--HdpzMq0yAVNL8KMxbb44QtbcxMhSx_NUud5b8PLUBFehAIxOBO-iYRIJOknEFkIJmdsofdVJ6uOweQ=="
              : Cookies.get("rwg_token");
          const savedMerchantId = Cookies.get("merchant_id");
          const conversionMerchantId = event.merchantId;

          if (!rwgToken || !conversionMerchantId) {
            return;
          }

          // This value should be used when the customer completed a transaction through the original Entity (Merchant).
          let merchantChanged = 2;

          //   This value should be used when a user has left the original merchant's website and completed a purchase through your platform with a different merchant
          if (savedMerchantId !== conversionMerchantId) {
            merchantChanged = 1;
          }

          const url =
            environment === "production"
              ? "https://www.google.com/maps/conversion/collect"
              : "https://www.google.com/maps/conversion/debug/collect";

          fetch(url, {
            method: "POST",
            mode: "no-cors",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              // This merchant_id must be the same as the one you have shared with Google in your feed.
              // On Google Actions Center, under Configuration > Account and Users
              conversion_partner_id: 20002921,
              rwg_token: rwgToken,
              merchant_changed: merchantChanged,
            }),
          })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              console.log("Success:", data);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
          break;
        default:
          console.error(`Analytics: event ${event.event} not supported yet.`);
          break;
      }
    },
    event: () => {},
  };
}
